import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const CHANGE_TABLE_SETTINGS = NS + 'CHANGE_TABLE_SETTINGS'

export const TABLE_ASSOCIATE_PAYMENTS = 'associatePayments'

export const FIND_UNASSIGNED_PAYMENT_LIST_REQUEST = NS + 'FIND_UNASSIGNED_PAYMENT_LIST_REQUEST'
export const FIND_UNASSIGNED_PAYMENT_LIST_SUCCESS = NS + 'FIND_UNASSIGNED_PAYMENT_LIST_SUCCESS'
export const FIND_UNASSIGNED_PAYMENT_LIST_ERROR = NS + 'FIND_UNASSIGNED_PAYMENT_LIST_ERROR'

export const EDIT_UNASSIGNED_PAYMENT = NS + 'EDIT_UNASSIGNED_PAYMENT'

export const CHANGE_CUSTOMER = NS + 'CHANGE_CUSTOMER'
export const CHANGE_SALES_ORDER = NS + 'CHANGE_SALES_ORDER'

export const ASSOCIATE_PAYMENT_REQUEST = NS + 'ASSOCIATE_PAYMENT_REQUEST'
export const ASSOCIATE_PAYMENT_SUCCESS = NS + 'ASSOCIATE_PAYMENT_SUCCESS'
export const ASSOCIATE_PAYMENT_ERROR = NS + 'ASSOCIATE_PAYMENT_ERROR'

export const DELETE_PAYMENT_REQUEST = NS + 'DELETE_PAYMENT_REQUEST'
export const DELETE_PAYMENT_SUCCESS = NS + 'DELETE_PAYMENT_SUCCESS'
export const DELETE_PAYMENT_ERROR = NS + 'DELETE_PAYMENT_ERROR'




// WEBPACK FOOTER //
// ./src/modules/payment/state/associate-payment/type.js